export default __webpack_public_path__ + "static/media/pnFin.6996e5bb.png";